export default __webpack_public_path__ + "assets/fonts/BerninaSans-NarrowSemibold.9dfe51ebcc51cfb0029afac0b97c268e.otf";